module.exports = __webpack_public_path__ + "fonts/GothamPro-Medium.1eb71eb0.woff";